import React from 'react';

export const SectionLabel = ({ children, className = '', center = false, light = false }) => (
  <div className={`flex items-center gap-3 ${center ? 'justify-center' : ''} ${className}`}>
    <span className={`h-px w-8 ${light ? 'bg-ophir-gold' : 'bg-ophir-gold'}`} />
    <span
      className={`text-[12px] font-semibold uppercase tracking-[0.16em] ${
        light ? 'text-ophir-gold-soft' : 'text-ophir-gold-deep'
      }`}
    >
      {children}
    </span>
  </div>
);
